.body {
  padding: 15px;
}

.log {
  margin-bottom: 5px;
}
